import React, { useEffect } from 'react'
import MUIDataTable from "mui-datatables";
import editIcon from '../../assets/ic_detail.png';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Typography, withStyles } from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import api from '../api';
import filterIcon from '../../assets/ic_search@3x.png';
import Loader from 'react-loader-spinner'
import { useHistory } from 'react-router-dom';
import AddSkrining from './addSkrining';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()
const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

export default function SkrinningPasien(props) {
    const history = useHistory()
    const [list, setList] = React.useState([])
    const [detailPoli, setDetaiPoli] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [visibleDetail, setVisibleDetail] = React.useState(false)
    const [visibleCreate, setVisibleCreate] = React.useState(false)

    React.useEffect(() => {
        props.setShowNotif(true)
        getData()
        // setLoading(true)
    }, [])

    const getData = () => {
        api.create().getTransactionScrenning().then(resp => {
            if (resp.data) {
                if (resp.data.status === true) {
                    if (resp.data.data?.length >= 0) {
                        console.log(resp);
                        resp.data.data.map((el, idx) => {
                            el["No"] = idx + 1
                        })
                        setList(resp.data.data)
                        setLoading(false)
                    }
                }
            }
        })
    }

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        const id = rowData[rowData.length - 1]
        console.log(id);
        // api.create().getTransactionScrenningDetail(id).then(response => {
            //     console.log(response);
            //     if (response) {
        //         setLoading(false)
            // setLoading(true)
        history.push({
            pathname: '/transaksi/detail-skrining-pasien',
            name: 'Detail Skrining Pasien',
            state: {
                // data: response.data.data,
                detail: rowData,
                id
            }
        })

        //     }
        // })
    }

    const onClose = () => {
        setVisibleDetail(false)
        setVisibleCreate(false)
    }

    const columns = [{
        name: "No",
        options: {
            filter: false,
            sortThirdClickReset: true,
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ textAlign: 'left' }}>
                        {val}
                    </div>
                )
            }
        }
    },
    {
        name: "reservasi_id",
        label: "ID Reservasi",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "screening_date",
        label: "Tanggal Skrining",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "visitor_name",
        label: "Nama Pengunjung",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "birth_date",
        label: "Tanggal Lahir",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "user_type",
        label: "Jenis Pengunjung",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "patient_name",
        label: "Nama Pasien",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "score",
        label: "Skor",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "screening_from",
        label: "Input",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "status",
        label: "Status",
        options: {
            sortThirdClickReset: true,
        }
    },
    {
        name: "Aksi",
        options: {
            filter: false,
            sort: false,
            customBodyRender: (val, tableMeta) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button
                            style={{
                                backgroundColor: "transparent",
                                fontSize: 20,
                                outline: 'none',
                                borderColor: 'transparent',
                                marginRight: 20
                            }
                            }
                            onClick={() => handleSeeDetail(tableMeta)}
                        >
                            <img src={editIcon} style={{ width: 30, height: 30 }} />
                        </button>
                    </div>
                )
            }
        }
    },
    {
        name: "id",
        options: {
            display: false,
            filter: false
        }
    }
    ];

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            {loading ? loadingComponent : null}
            <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10' }}>
                <button style={{ padding: 5, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                // onClick={() => onOpen()}
                >
                    <div 
                        onClick={() => setVisibleCreate(true)}
                        style={{ display: 'flex' }}>
                        <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                        <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tambah Baru</Typography>
                    </div>
                </button>
            </div>
            <div >
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={list}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>
            </div>
            {
                visibleCreate ? 
                <AddSkrining
                    data={list}
                    onClose = {() => setVisibleCreate(false)}
                />
                :null
            }
        </div>
    )

}